import React from "react";
import { GiftIcon } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { bonuses } from "../data/landingContent";
import { CTAButton } from "./CTAButton";
const bonusDetails = [{
  title: "Directorio de proveedores",
  description: "Proveedores organizados por provincia en Argentina.",
  accent: "bg-[#dff3ff] text-[#0077e8]"
}, {
  title: "Planilla Excel de costos y precios",
  description: "Organizá tus costos y calculá el precio de tus productos.",
  accent: "bg-[#e2f7ed] text-[#13845d]"
}, {
  title: "Plantillas de etiquetas profesionales",
  description: "Diseños editables para personalizar la presentación de tus productos.",
  accent: "bg-[#ffe8e8] text-[#ca5d5d]"
}, {
  title: "Detergente · Lote de 100 kg",
  description: "Fórmula completa para conocer el proceso de elaboración a mayor escala.",
  accent: "bg-[#e4faf2] text-[#07966b]"
}, {
  title: "Fórmulas automotrices",
  description: "Manual exclusivo con fórmulas para limpieza y cuidado automotor.",
  accent: "bg-[#fff0df] text-[#c56a11]"
}];
const enterEase = [0.22, 1, 0.36, 1] as const;
export function BonusShowcase() {
  const reduceMotion = useReducedMotion();
  return <section id="bonos" className="bg-white py-16 sm:py-24 lg:py-28" style={{
    paddingTop: "28px",
    paddingBottom: "40px"
  }} data-id="element-18" data-mp="1mmg7n7vnx3lj">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" data-id="element-19" data-mp="1rdeoc8kkc3pb">
        <motion.div className="mx-auto max-w-3xl text-center" initial={reduceMotion ? false : {
        opacity: 0,
        y: 8
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.45,
        ease: enterEase
      }} data-id="element-20" data-mp="1rezgxsnbhckj">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#e9f6ff] px-3 py-1.5 text-[11px] font-extrabold tracking-[0.08em] text-[#0077e8]" data-id="element-21" data-mp="2acahrholke23"><GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="b0rbjauohjw4" />DE REGALO · SOLO POR HOY</div>
          <h2 className="mt-5 text-[clamp(1.9rem,8.5vw,2.15rem)] font-extrabold leading-[1.04] tracking-[-0.06em] text-[#091a37] sm:text-4xl" data-id="element-23" data-mp="fy9jaxwylt2j"><span className="block" data-id="element-24" data-mp="2y8kbkvu45rp">Y además, recibís</span><span className="block text-[#0077e8]" data-id="element-25" data-mp="2zihm7uv59xa">5 BONOS DE REGALO</span></h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-[#526078]" data-id="element-26" data-mp="hvrex3v71d72">5 herramientas complementarias para ayudarte a llevar las fórmulas a la práctica y empezar con más recursos.</p>
        </motion.div>

        <div className="mt-10 border-t border-[#dce4ed] lg:mt-14 lg:grid lg:grid-cols-3 lg:gap-x-10" data-id="element-27" data-mp="quv0qflqw6p9">
          {bonuses.map((bonus, index) => {
          const detail = bonusDetails[index];
          const imageFirst = index % 2 === 0;
          return <article key={bonus.number} className={`grid grid-cols-[.92fr_1.08fr] items-center gap-4 border-b border-[#dce4ed] py-7 lg:block lg:py-9 ${index === 3 ? "lg:col-start-1" : ""}`} data-id="element-28" data-mp="10ntpbxh8rx8v" data-mpi={index}>
                <motion.div className={`${imageFirst ? "order-1" : "order-2"} lg:order-none`} initial={reduceMotion ? false : {
              opacity: 0,
              x: imageFirst ? -12 : 12
            }} whileInView={reduceMotion ? undefined : {
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              amount: 0.25
            }} transition={{
              duration: 0.5,
              ease: enterEase
            }} data-id="element-29" data-mp="19kkvx3tf6uhp">
                  <img src={bonus.image} alt={`Portada del ${detail.title}`} className="mx-auto w-full max-w-[240px] object-contain drop-shadow-[0_13px_16px_rgba(9,26,55,0.14)] lg:max-w-[270px]" data-id="element-30" data-mp="1k6pv5t7sxnxq" />
                </motion.div>
                <motion.div className={`${imageFirst ? "order-2" : "order-1"} lg:mt-5 lg:order-none`} initial={reduceMotion ? false : {
              opacity: 0,
              y: 6
            }} whileInView={reduceMotion ? undefined : {
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.25
            }} transition={{
              duration: 0.45,
              delay: 0.1,
              ease: enterEase
            }} data-id="element-31" data-mp="1ab63jj09tbes">
                  <span className={`inline-flex rounded-full px-2.5 py-1 text-[10px] font-extrabold tracking-[0.09em] ${detail.accent}`} data-id="element-32" data-mp="1twrnkcx2dyk1">{bonus.number}</span>
                  <h3 className="mt-3 text-[18px] font-extrabold leading-[1.1] tracking-[-0.045em] text-[#091a37] sm:text-xl" data-id="element-33" data-mp="1pxagjf1zotcr">{detail.title}</h3>
                  <p className="mt-2 text-[13px] leading-[1.4] text-[#657189]" data-id="element-34" data-mp="1g41yu0q5ifj8">{detail.description}</p>
                </motion.div>
              </article>;
        })}
        </div>

        <motion.div className="mt-9 rounded-2xl bg-[#edf8ff] px-5 py-6 text-center lg:mt-12" initial={reduceMotion ? false : {
        opacity: 0,
        y: 8
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.42,
        ease: enterEase
      }} style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-35" data-mp="166ffn21tk1tg">
          <span className="mx-auto flex h-8 w-8 items-center justify-center rounded-full bg-[#0077e8] text-white" data-id="element-36" data-mp="2wha6oaulypky"><GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="2rifhmr61s4se" /></span>
          <p className="mt-3 text-[11px] font-extrabold tracking-[0.12em] text-[#263754]" data-id="element-38" data-mp="2z39l68wyhkes">5 BONOS INCLUIDOS CON TU ACCESO</p>
          <p className="mt-2 text-sm leading-6 text-[#526078]" data-id="element-39" data-mp="340t25gl1gbaf">Más herramientas para pasar de aprender las fórmulas a ponerlas en práctica.</p>
        </motion.div>
        <div className="mt-6 text-center" data-id="element-40" data-mp="3drdvaohy0nly"><CTAButton tone="blue" shimmer className="min-h-[58px] w-full sm:min-w-[240px]" data-id="element-41" data-mp="3durvpr71qmqr">QUIERO EMPEZAR</CTAButton></div>
      </div>
    </section>;
}